<div class="contacts">
  <section>
    <div class="section-header">
      <h3 class="list-heading">
        @if (facility()?.facilityName?.trim(); as facilityName) {
          {{
            'COMMERCIAL_SERVICES.LABEL.NAMED_FACILITY_CONTACTS'
              | translate: { facilityName }
          }}
        } @else {
          {{ 'COMMERCIAL_SERVICES.LABEL.FACILITY_CONTACTS' | translate }}
        }
      </h3>
      @if (writeAccess() && !isHistoricalRecord()) {
        <p-button
          icon="fa fa-pencil"
          [label]="'COMMERCIAL_SERVICES.LABEL.MANAGE_CONTACTS' | translate"
          (onClick)="openManageContacts()"
        />
      }
    </div>

    @if (contactsDirty()) {
      <p class="save-reminder" role="status">
        {{ 'COMMERCIAL_SERVICES.LABEL.CONTACT_CHANGES_UNSAVED' | translate }}
      </p>
    }

    @if (orderedContacts().length === 0) {
      <p class="empty">
        {{ 'COMMERCIAL_SERVICES.LABEL.NO_CONTACT_ASSIGNED' | translate }}
      </p>
    }
  </section>

  @for (group of roleGroups(); track group.jobRoleId) {
    <p-divider />

    <section>
      <h2 class="role-heading">{{ group.name }}</h2>
      <div class="cards">
        @for (member of group.members; track member.contact.id) {
          @let contact = member.contact;
          <p-card class="contact-card">
            <ng-template #header>
              <div
                class="card-header"
                [class.clickable]="canOpenContacts()"
                [attr.role]="canOpenContacts() ? 'button' : null"
                [attr.tabindex]="canOpenContacts() ? 0 : null"
                [pTooltip]="
                  canOpenContacts()
                    ? ('COMMERCIAL_SERVICES.LABEL.VIEW_CONTACT' | translate)
                    : ''
                "
                tooltipPosition="top"
                (click)="canOpenContacts() && openContact.emit(contact.id)"
                (keydown.enter)="
                  canOpenContacts() && openContact.emit(contact.id)
                "
              >
                <span class="position">{{ member.position }}</span>
                <span class="name">{{ fullName(contact) }}</span>
                <span class="company">{{ contact.company?.name }}</span>
              </div>
            </ng-template>

            <dl class="details">
              <dt>
                {{ 'COMMERCIAL_SERVICES.LABEL.OFFICE_NUMBER' | translate }}
              </dt>
              <dd>
                @if (contact.deskPhone) {
                  <a [href]="'tel:' + contact.deskPhone">{{
                    contact.deskPhone
                  }}</a>
                } @else {
                  —
                }
              </dd>
              <dt>
                {{ 'COMMERCIAL_SERVICES.LABEL.MOBILE_NUMBER' | translate }}
              </dt>
              <dd>
                @if (contact.mobilePhone) {
                  <a [href]="'tel:' + contact.mobilePhone">{{
                    contact.mobilePhone
                  }}</a>
                } @else {
                  —
                }
              </dd>
              <dt>{{ 'COMMERCIAL_SERVICES.LABEL.EMAIL' | translate }}</dt>
              <dd>
                @if (contact.emailAddress) {
                  <a [href]="'mailto:' + contact.emailAddress">{{
                    contact.emailAddress
                  }}</a>
                } @else {
                  —
                }
              </dd>
              <dt>{{ 'COMMERCIAL_SERVICES.LABEL.ICE' | translate }}</dt>
              <dd>{{ contact.ice || '—' }}</dd>
            </dl>
          </p-card>
        }
      </div>
    </section>
  }
</div>
